
// src/components/ParallaxLayer.js
import React from 'react';

const ParallaxLayer = ({ index, depth, scale, color, image, zIndex, children }) => {
  const style = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transform: `translateZ(${depth}px) scale(${scale})`,
    zIndex,
    willChange: 'transform',
    backgroundColor: color || undefined,
    backgroundImage: image ? `url(${image})` : undefined,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <div className={`parallax-layer layer-${index}`} style={style} data-depth={depth} data-scale={scale}>
      {children}
    </div>
  );
};

export default ParallaxLayer;